// What every events screen shares: the types and their colours, who an event is for, the answers.

export const EVENT_TYPES = [
  { value: 'conference',     label: 'Conference' },
  { value: 'congress',       label: 'Congress' },
  { value: 'workshop',       label: 'Workshop' },
  { value: 'symposium',      label: 'Symposium' },
  { value: 'seminar',        label: 'Seminar' },
  { value: 'webinar',        label: 'Webinar' },
  { value: 'summit',         label: 'Summit' },
  { value: 'hackathon',      label: 'Hackathon' },
  { value: 'colloquium',     label: 'Colloquium' },
  { value: 'lecture_series', label: 'Lecture Series' },
  { value: 'training',       label: 'Training Course' },
  { value: 'group_meeting',  label: 'Group Meeting' },
  { value: 'journal_club',   label: 'Journal Club' },
  { value: 'other',          label: 'Other' },
];

export const TYPE_COLORS = {
  conference:     '#764ba2',
  congress:       '#667eea',
  workshop:       '#e67e22',
  symposium:      '#16a085',
  seminar:        '#2980b9',
  webinar:        '#8e44ad',
  summit:         '#c0392b',
  hackathon:      '#27ae60',
  colloquium:     '#d35400',
  lecture_series: '#1abc9c',
  training:       '#f39c12',
  group_meeting:  '#0f766e',
  journal_club:   '#b45309',
  other:          '#7f8c8d',
};

export const typeColor = (type) => TYPE_COLORS[type] || TYPE_COLORS.other;

export const STATUS_COLORS = {
  upcoming:  'primary',
  ongoing:   'success',
  past:      'default',
  cancelled: 'error',
};

export const VISIBILITY = [
  { value: 'public',     label: 'Everyone on Otable' },
  { value: 'lab',        label: 'Members of a lab' },
  { value: 'consortium', label: 'Members of a consortium' },
  { value: 'private',    label: 'Only people I invite' },
];

export const RSVP_LABELS = {
  going:      'Going',
  interested: 'Interested',
  declined:   "Can't go",
  invited:    'Invited',
};

export function formatDateRange(start, end) {
  if (!start) return '';
  const s = new Date(start);
  const fmt = (d) => d.toLocaleDateString('en-US', { day: 'numeric', month: 'short', year: 'numeric' });
  if (!end) return fmt(s);
  const e = new Date(end);
  if (s.toDateString() === e.toDateString()) return fmt(s);
  if (s.getFullYear() === e.getFullYear() && s.getMonth() === e.getMonth())
    return `${s.getDate()}–${fmt(e)}`;
  return `${fmt(s)} – ${fmt(e)}`;
}

// Group meetings and seminars have a time worth showing; multi-day conferences do not.
export function formatWhen(start, end) {
  if (!start) return '';
  const s = new Date(start);
  const sameDay = !end || s.toDateString() === new Date(end).toDateString();
  if (!sameDay) return formatDateRange(start, end);
  const time = (d) => d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  const day = s.toLocaleDateString('en-US', { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric' });
  if (s.getHours() === 0 && s.getMinutes() === 0) return day;
  return end ? `${day}, ${time(s)}–${time(new Date(end))}` : `${day}, ${time(s)}`;
}

// "Ayşe and 3 other connections are going"
export function connectionsLine(event) {
  const n = event.connections_going || 0;
  if (!n) return '';
  const first = (event.going_preview || []).find((p) => p.is_connection);
  if (!first) return `${n} of your connections ${n === 1 ? 'is' : 'are'} going`;
  const name = first.name.split(' ')[0];
  if (n === 1) return `${name} is going`;
  return `${name} and ${n - 1} other connection${n - 1 === 1 ? '' : 's'} are going`;
}
